import Cookies from 'js-cookie';
export default class bannerController {

	constructor() {
		this.bannerCookie = Cookies.getJSON('bannerCookie');
		this.cookieCheck();
		this.SetupButtonClicks();

		// document.addEventListener('DOMContentLoaded', () => {
		// 	this.alertRibbon = document.querySelector('#alertRibbon');
		// 	this.moveHeaderAndContent();
		// });

		// window.onresize = () => this.moveHeaderAndContent();
	}

	SetupButtonClicks() {
		if (this.alertRibbon !== null && this.alertRibbon !== undefined) {
			document.querySelector('#close-alertRibbon').addEventListener('click', this.hide.bind(this));
			document.querySelector('.menuButton').addEventListener('click', this.hide.bind(this));
		}
	}
	cookieCheck() {
		if (this.bannerCookie === undefined) {
			this.show()
		}
		else {
			this.hide();
		}
    }
	moveHeaderAndContent() {
		const contentMarginBase = 80;

		if (this.alertRibbon !== null && this.alertRibbon !== undefined) {
			if (this.alertRibbon.offsetHeight === 0) {
				this.resetHamburgerPosition();
			} else {
				$('header').css('margin-top', `${this.alertRibbon.offsetHeight}px`);
				$('#hero').css('margin-top', `calc(${contentMarginBase}px + ${this.alertRibbon.offsetHeight}px)`);
				document.querySelector('section#hero').classList.add('headerBannerMargin')
			}
		} else {
			this.resetHamburgerPosition();
		}
	}

	resetHamburgerPosition() {
		setTimeout(() => {
			document.querySelector('section#hero').classList.remove('headerBannerMargin')
			$('header').css('margin-top', '');
			$('#hero').css('margin-top', '');
			if (document.querySelector('.menuButtonBanner') !== null) {
				document.querySelector('.menuButtonBanner').classList.remove('menuButtonBanner');
			}
		}, 400);
	}

	show() {
		if (this.alertRibbon !== null && this.alertRibbon !== undefined) {
			this.alertRibbon.classList.remove('hidden');
		}
	}

	hide() {
		if (this.alertRibbon !== null && this.alertRibbon !== undefined) {
			this.alertRibbon.classList.add('hidden');
			this.alertRibbon.style.height = "0px";
			this.moveHeaderAndContent()
			this.bannerCookie = {
				Hide: true
			};

			window.dataLayer = window.dataLayer || [];

			window.dataLayer.push({
				"Hide": true,

			});

			Cookies.set('bannerCookie', this.bannerCookie, {
				expires: 1
			});
		}
	}
};